import styled, { DefaultTheme, keyframes } from 'styled-components';

const loadingAnimation = keyframes`
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export interface DivStyledComponentProps {
  display?: string;
  width?: string | number;
  maxWidth?: string;
  minWidth?: string;
  height?: string | number;
  minHeight?: string;
  maxHeight?: string;
  margin?: string;
  padding?: string;
  border?: string;
  borderRadius?: string;
  cursor?: string;
  color?: string;
  bg?: string;
  fontSize?: string;
  fontWeight?: string;
  opacity?: string;
  position?: string;
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
  zIndex?: string;
  textAlign?: string;
  boxShadow?: string;
  overflow?: string;
  whiteSpace?: string;
  gridArea?: string;

  themeBgColor?: keyof DefaultTheme;

  flexDirection?: string;
  flexWrap?: string;
  align?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'baseline'
    | 'stretch'
    | 'inherit'
    | 'initial'
    | 'unset';
  justify?: string;
  justifySelf?: string;
  alignSelf?: string;
  gap?: string;
}

export const StyledDiv = styled.div<DivStyledComponentProps>`
  display: ${(props) => props.display || ''};
  width: ${(props) => props.width || ''};
  min-width: ${(props) => props.minWidth || ''};
  max-width: ${(props) => props.maxWidth || ''};
  height: ${(props) => props.height || ''};
  min-height: ${(props) => props.minHeight || ''};
  max-height: ${(props) => props.maxHeight || ''};
  margin: ${(props) => props.margin || ''};
  padding: ${(props) => props.padding || ''};
  position: ${(props) => props.position || ''};
  z-index: ${(props) => props.zIndex || ''};
  text-align: ${(props) => props.textAlign || ''};
  background-color: ${(props) => props.bg || ''};
  background-color: ${({ theme, themeBgColor }) => (themeBgColor ? theme[themeBgColor] : '')};
  color: ${(props) => props.color || ''};
  border: ${(props) => props.border || ''};
  border-radius: ${(props) => props.borderRadius || ''};
  opacity: ${(props) => props.opacity || ''};
  overflow: ${(props) => props.overflow || ''};
  box-shadow: ${(props) => props.boxShadow || ''};
  cursor: ${(props) => props.cursor || ''};
  height: ${(props) => props.height || ''};
  min-height: ${(props) => props.minHeight || ''};
  border-radius: ${(props) => props.borderRadius || ''};
  border: ${(props) => props.border || ''};
  left: ${(props) => props.left || ''};
  right: ${(props) => props.right || ''};
  top: ${(props) => props.top || ''};
  bottom: ${(props) => props.bottom || ''};
  font-weight: ${(props) => props.fontWeight || ''};
  font-size: ${(props) => props.fontSize || ''};
  white-space: ${(props) => props.whiteSpace || ''};

  ${(props) => (props.gridArea ? `grid-area: ${props.gridArea};` : '')}

  flex-direction: ${(props) => props.flexDirection || ''};
  flex-wrap: ${(props) => props.flexWrap || ''};
  gap: ${(props) => props.gap || '0'};
  justify-content: ${(props) => props.justify || ''};
  align-items: ${(props) => props.align || ''};
  justify-self: ${(props) => props.justifySelf || ''};
  align-self: ${(props) => props.alignSelf || ''};
`;

export const LoadingBox = styled(StyledDiv).attrs((props: DivStyledComponentProps) => {
  return {
    borderRadius: props.borderRadius ?? '0.25rem',
  };
})`
  animation: ${loadingAnimation} 1.5s infinite;
  animation-fill-mode: both;
  background: linear-gradient(
    to left,
    ${({ theme }) => theme.bg0} 25%,
    ${({ theme }) => theme.bg2} 50%,
    ${({ theme }) => theme.bg0} 75%
  );
  background-size: 400%;
  will-change: background-position;

  & > * {
    visibility: hidden;
  }
`;
